module.exports = __webpack_public_path__ + "static/media/entrance-header.60aad1ec.png";